"use strict";
/**
 * AngularJS toolbar components.
 *
 * @packageDocumentation
 * @module Toolbar
 * @preferred
 */
Object.defineProperty(exports, "__esModule", { value: true });
var toolbar_module_1 = require("./toolbar.module");
exports.TOOLBAR_MODULE_NAME = toolbar_module_1.MODULE_NAME;
var toolbar_component_1 = require("./toolbar.component");
exports.TOOLBAR_COMPONENT_NAME = toolbar_component_1.COMPONENT_NAME;
//# sourceMappingURL=index.js.map